module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "about-map-area"
  }, [_c('div', {
    staticClass: "about-map-area-box"
  }, [_c('div', {
    staticClass: "about-map-area-box-img wow flipInX"
  }, [_c('baidu-map', {
    staticClass: "map-container",
    attrs: {
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom,
      "scroll-wheel-zoom": true,
      "lang": _vm.lang
    },
    on: {
      "ready": _vm.handler
    }
  }, [_c('bm-marker', {
    attrs: {
      "z-index": 100,
      "top": true,
      "position": {
        lng: 120.73912,
        lat: 31.283159
      },
      "title": "人民大学苏州校区",
      "icon": {
        url: require('../assets/lo.png'),
        size: {
          width: 30,
          height: 30
        }
      },
      "animation": "BMAP_ANIMATION_BOUNCE"
    }
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "about-top",
    attrs: {
      "id": "message"
    }
  }, [_c('div', {
    staticClass: "about-top-box container"
  }, [_c('div', {
    staticClass: "about-top-box-text"
  }, [_c('h1', {
    staticClass: "wow slideInRight"
  }, [_vm._v("Welcome Message")]), _vm._v(" "), _c('p', {
    staticClass: "wow slideInLeft"
  }, [_vm._v("\n              Suzhou Campus of RUC, the only campus outside Beijing, is located in Suzhou Dushu Lake Science and Education Innovation Zone, the first \"Internationalization Demonstration Zone of Higher Education \" in China.\n              It is an outstanding achievement of the cooperation between RUC and Suzhou Municipal Government. As an important part of the overall development of RUC, it aims at cultivating top-notch and innovative talents with an international outlook, a good understanding of international rules and regulations, and the ability to participate in international affairs and compete worldwidely. Over the past two decades, the International College, the Sino-French Institute and School of Smart Governance have been established successively, with over 8,000 students of RUC having gone to the world from here.\n            ")]), _vm._v(" "), _c('img', {
    staticClass: "wow slideInRight about-top-box-text-img",
    staticStyle: {
      "clear": "both"
    },
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/about/ld.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "wow slideInLeft about-top-box-text-content"
  }, [_vm._v("\n\n              At present, Suzhou Campus is endeavoring to fulfill its historical mission of serving the regional socio-economic and cultural development, prospering philosophy and social sciences, and building RUC into a world-class university that wins people’s trust. We sincerely expect talents like you who are possessed with Chinese sentiment and global vision to meet us here in the south of the Yangtze River, to show your talents and gain a bright future!\n\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "about-top-box-text-p"
  }, [_c('div', {
    staticClass: "about-top-box-text-p-des"
  }, [_vm._v("\n                Vice Director of the Management Committee of Suzhou Campus"), _c('br'), _vm._v("\n                Dean of Yuanjian College"), _c('br'), _vm._v("\n                Dean of Sino-French Institute"), _c('br'), _vm._v("\n                Dean of International College (Suzhou Research Institute)"), _c('br'), _vm._v("\n                Dean of School of Smart Governance\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "about-top-box-text-p-name"
  }, [_vm._v("WANG Xiaohu")]), _vm._v(" "), _c('div', {
    staticClass: "about-top-box-text-p-des",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("Chair of the University Council of Suzhou Campus")]), _vm._v(" "), _c('div', {
    staticClass: "about-top-box-text-p-name"
  }, [_vm._v("WU Cong")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "people-area",
    attrs: {
      "id": "leader"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "people-area-top text-center wow pulse"
  }, [_vm._v("\n              Leaders\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "people-area-box"
  }, [_c('div', {
    staticClass: "people-area-box-lf"
  }), _vm._v(" "), _c('div', {
    staticClass: "people-area-box-mid row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "loader-slider owl-carousel owl-pc"
  }, [_c('div', {
    staticClass: "single-slide"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-img"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/about/user2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "people-area-box-mid-item-content"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-content-tit"
  }, [_c('h3', [_vm._v("ZHENG Xinye")])]), _vm._v(" "), _c('div', {
    staticClass: "people-area-box-mid-item-content-nr"
  }, [_vm._v("\n                            Member of the University Council,Vice President,"), _c('br'), _vm._v("\n                            Director of the Management Committee of Suzhou Campus.\n                          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-img"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/about/user1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "people-area-box-mid-item-content"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-content-tit"
  }, [_c('h3', [_vm._v("WANG Xiaohu")])]), _vm._v(" "), _c('div', {
    staticClass: "people-area-box-mid-item-content-nr"
  }, [_vm._v("\n                            Vice Director of the Management Committee of Suzhou Campus,"), _c('br'), _vm._v("\n                            Dean of Yuanjian College,"), _c('br'), _vm._v("\n                            Dean of Sino-French Institute,"), _c('br'), _vm._v("\n                            Dean of International College (Suzhou Research Institute),"), _c('br'), _vm._v("\n                            Dean of School of Smart Governance.\n                          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-img"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/about/user.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "people-area-box-mid-item-content"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-content-tit"
  }, [_c('h3', [_vm._v("WU Cong ")])]), _vm._v(" "), _c('div', {
    staticClass: "people-area-box-mid-item-content-nr"
  }, [_vm._v("\n                            Chair of the University Council of Suzhou Campus."), _c('br')])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "loader-slider owl-carousel owl-mobile"
  }, [_c('div', {
    staticClass: "single-slide"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-content"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-content-tit"
  }, [_c('h3', [_vm._v("ZHENG Xinye")])]), _vm._v(" "), _c('div', {
    staticClass: "people-area-box-mid-item-content-nr"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-img",
    staticStyle: {
      "float": "left",
      "clear": "both"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/about/user2.png",
      "align": "right",
      "width": "380",
      "hspace": "5",
      "vspace": "5",
      "alt": ""
    }
  })]), _vm._v("\n                            Member of the University Council,Vice President,"), _c('br'), _vm._v("\n                            Director of the Management Committee of Suzhou Campus.\n                          ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-slide"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-content"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-content-tit"
  }, [_c('h3', [_vm._v("WANG Xiaohu")])]), _vm._v(" "), _c('div', {
    staticClass: "people-area-box-mid-item-content-nr"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-img",
    staticStyle: {
      "float": "left",
      "clear": "both"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/about/user1.png",
      "alt": ""
    }
  })]), _vm._v("\n                            Vice Director of the Management Committee of Suzhou Campus,"), _c('br'), _vm._v("\n                            Dean of Yuanjian College,"), _c('br'), _vm._v("\n                            Dean of Sino-French Institute,"), _c('br'), _vm._v("\n                            Dean of International College (Suzhou Research Institute),"), _c('br'), _vm._v("\n                            Dean of School of Smart Governance.\n                          ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-slide"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-content"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-content-tit"
  }, [_c('h3', [_vm._v("WU Cong")])]), _vm._v(" "), _c('div', {
    staticClass: "people-area-box-mid-item-content-nr"
  }, [_c('div', {
    staticClass: "people-area-box-mid-item-img",
    staticStyle: {
      "float": "left",
      "clear": "both"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/about/user.png",
      "alt": ""
    }
  })]), _vm._v("\n                            Chair of the University Council of Suzhou Campus."), _c('br')])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "people-area-box-rt"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "about-map",
    attrs: {
      "id": "map"
    }
  }, [_c('div', {
    staticClass: "row about-map-box"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h1', {
    staticClass: "wow pulse"
  }, [_vm._v("Campus Map")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2e47926"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 82
// module chunks = 0